module.exports = __webpack_public_path__ + "static/navbar_mobile-4f72df3ce309702cfce6f3f9755ea7a2.png";